module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/components/ArrowBack.js");
  /******/
}
/************************************************************************/

/******/
({
  /***/
  "./src/components/ArrowBack.js":
  /***/
  function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("styled-components");
    /* harmony import */


    var styled_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("prop-types");
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */


    var _shared_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/components/shared-styles.js");

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }
    /* eslint-disable no-unused-vars */

    /* eslint-disable max-len */


    var _StyledSpan = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.span.withConfig({
      displayName: "_StyledSpan",
      componentId: "sc-6mv68s-0"
    })(["", ""], _shared_styles__WEBPACK_IMPORTED_MODULE_3__["default"]);

    var ArrowBack = function ArrowBack(_ref) {
      var height = _ref.height,
          width = _ref.width,
          color = _ref.color,
          className = _ref.className,
          secondaryColor = _ref.secondaryColor,
          props = _objectWithoutPropertiesLoose(_ref, ["height", "width", "color", "className", "secondaryColor"]);

      return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_StyledSpan, {
        className: className
      }, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("svg", _extends({
        viewBox: "0 0 6 10",
        height: height,
        width: width
      }, props, {
        xmlns: "http://www.w3.org/2000/svg"
      }), react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("g", {
        fill: color
      }, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("path", {
        d: "M5.19 10a.8.8 0 0 1-.55-.23L.26 5.48A.9.9 0 0 1 0 4.84a.92.92 0 0 1 .28-.63l4.38-4A.77.77 0 0 1 5.8.3a.87.87 0 0 1-.08 1.2L2 4.88l3.74 3.64a.88.88 0 0 1 0 1.21.76.76 0 0 1-.59.27"
      }))));
    };

    ArrowBack.propTypes = {
      height: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
      width: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
      color: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
      className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
      secondaryColor: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string
    };
    ArrowBack.defaultProps = {
      height: 25,
      width: 25,
      color: 'currentColor',
      className: '',
      secondaryColor: 'currentColor'
    };
    /* harmony default export */

    __webpack_exports__["default"] = ArrowBack;
    /***/
  },

  /***/
  "./src/components/shared-styles.js":
  /***/
  function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony default export */


    __webpack_exports__["default"] = "\n  display: inline-block;\n  position: relative;\n  user-select: none;\n";
    /***/
  },

  /***/
  "prop-types":
  /***/
  function (module, exports) {
    module.exports = require("prop-types");
    /***/
  },

  /***/
  "react":
  /***/
  function (module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  "styled-components":
  /***/
  function (module, exports) {
    module.exports = require("styled-components");
    /***/
  }
  /******/

});